import React from 'react';
import { string } from 'prop-types';

import { Placeholder } from '@thd-olt-component-react/core-ui';

import { isDollarThresholdBogo as isDollarThresholdBogoFn } from '../utils/promo-utils';
import { EXPERIENCE_TAGS } from '../utils/constants';

export const PromotionProductsLoader = ({ experienceTag, subExperienceTag }) => {

  const numRows = {
    [EXPERIENCE_TAGS.BOGO]: isDollarThresholdBogoFn({ subExperienceTag }) ? 4 : 5,
    [EXPERIENCE_TAGS.MSB]: 6,
    [EXPERIENCE_TAGS.BMSM]: 5,
    default: 5,
  };

  return (
    <>
      { new Array(numRows[experienceTag]).fill('').map((value, i) => (
        <Placeholder type="text" key={`row-${i}`} />
      ))}
    </>
  );
};

PromotionProductsLoader.displayName = 'PromotionProductsLoader';

PromotionProductsLoader.propTypes = {
  /**
   * the conditional promotion experienceTag.
   */
  experienceTag: string,
  /**
   * the conditional promotion subExperienceTag.
   */
  subExperienceTag: string,
};

PromotionProductsLoader.defaultProps = {
  experienceTag: 'default', // while we are awaiting promotion data
  subExperienceTag: null,
};
